import React, { useEffect, useState } from 'react';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';
import { ChatContent } from '../../components/Chat/ChatContent';
import { ChatSidebar } from '../../components/Chat/ChatSidebar';
import { useAuth } from '../../context/AuthContext';
import { useLayout } from '../../context/LayoutContext';
import { useScreenType } from '../../hooks/useScreenType';
import PremiumLock from '../../components/Common/PremiumLock';
import { History, X } from 'lucide-react';

const ChatPage: React.FC = () => {
  const { hasPermission } = useAuth();
  const { isSidebarCollapsed, toggleSidebar } = useLayout();
  const { isDesktop } = useScreenType();
  const [showMobileHistory, setShowMobileHistory] = useState(false);
  
  const isPro = hasPermission('view_advanced_data');

  // Le .content de SiteLayout ne défile pas : seul .messages-container défile. Il devient
  // une colonne flex le temps de cette page, pour que la conversation occupe exactement
  // la hauteur laissée par l'en-tête (et par la barre de navigation mobile). Avec un
  // simple `height: 100%`, la page dépassait de la hauteur de l'en-tête et la saisie
  // sortait de l'écran (constaté le 2026-10-01).
  useEffect(() => {
    const contentEl = document.querySelector('.content') as HTMLElement | null;
    if (contentEl) {
      contentEl.style.overflowY = 'hidden';
      contentEl.style.display = 'flex';
      contentEl.style.flexDirection = 'column';
      return () => {
        contentEl.style.overflowY = 'auto';
        contentEl.style.display = '';
        contentEl.style.flexDirection = '';
      };
    }
  }, []);

  // Auto-collapse main sidebar on mount for chat
  useEffect(() => {
    if (!isSidebarCollapsed) {
      toggleSidebar();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SiteLayout>
      <Header 
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
            {!isDesktop && (
              <button 
                onClick={() => setShowMobileHistory(!showMobileHistory)}
                style={{ background: 'none', border: 'none', padding: '4px', color: 'var(--text-main)', marginRight: '8px', display: 'flex', alignItems: 'center' }}
              >
                <History size={20} />
              </button>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ 
                width: '10px', 
                height: '10px', 
                backgroundColor: '#22c55e', 
                borderRadius: '50%',
                display: 'inline-block' 
              }} />
              <span style={{ fontWeight: 700, fontSize: '1.4rem', color: 'var(--text-heading)' }}>Nia</span>
              <span className="responsive-hide" style={{ 
                fontSize: '1rem', 
                color: 'var(--text-muted)', 
                fontWeight: 400,
                marginLeft: '4px'
              }}>Analyste IA · BRVM</span>
            </div>
          </div>
        }
        metaTitle="Discuter avec Nia"
      />
      
      <div
        className="chat-page-main"
        style={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}
      >
        {/* Sidebar logic */}
        {isDesktop ? (
          <ChatSidebar />
        ) : (
          showMobileHistory && (
            <>
              <div className="chat-mobile-sidebar-overlay" onClick={() => setShowMobileHistory(false)} />
              <div className="chat-mobile-sidebar">
                <div className="mobile-sidebar-header-row">
                  <span>Historique de discussion</span>
                  <button onClick={() => setShowMobileHistory(false)}>
                    <X size={20} />
                  </button>
                </div>
                <ChatSidebar onCloseMobile={() => setShowMobileHistory(false)} />
              </div>
            </>
          )
        )}

        <div style={{ flex: 1, minHeight: 0, height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <ChatContent />
        </div>
      </div>
    </SiteLayout>
  );
};

export default ChatPage;
